const APP = 'PETROL_PUMP'

export const LOGIN = `${APP}:AUTH:LOGIN`;
export const LOGOUT = `${APP}:AUTH:LOGOUT`;
export const REFETCH = `${APP}:AUTH:REFETCH`;
